module.exports = __webpack_public_path__ + "static/media/cert_-2.2cb66f46.jpg";